const _ = require("lodash");
const channels = require("./app__channels").channels;
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const youtube = _.find(channels, { channel_short_name: "youtube" });
const twitter = _.find(channels, { channel_short_name: "twitter" });
const reddit = _.find(channels, { channel_short_name: "reddit" });
const snapchat = _.find(channels, { channel_short_name: "snapchat" });

module.exports = [
  {
    budget: 500,
    minClicks: 300,
    name: "Social Media Booster S",
    id: "aws--small-facebook-instagram-s",
    nameShort: "S",
    description: "Facebook & Instagram / 300 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram]
  },
  {
    budget: 800,
    minClicks: 480,
    name: "Social Media Booster M",
    id: "aws--small-facebook-instagram-m",
    nameShort: "M",
    description: "Facebook & Instagram / 480 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram]
  },
  {
    budget: 1200,
    minClicks: 720,
    name: "Social Media Booster L",
    id: "aws--small-facebook-instagram-youtube-l",
    nameShort: "L",
    description: "Facebook & Instagram & YouTube / 720 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram, youtube]
  },
  {
    budget: 2000,
    minClicks: 1200,
    name: "Social Media Booster XL",
    id: "aws--small-facebook-instagram-youtube-xl",
    nameShort: "XL",
    description: "Facebook & Instagram & YouTube / 1200 qualifizierte Klicks / 30 Tage Laufzeit",
    color: "#B0D59D",
    selectedChannels: [facebook, instagram, youtube]
  },
  {
    budget: 1200,
    minClicks: 720,
    name: "Erzieher Booster",
    id: "aws--erzieher-booster",
    nameShort: "👥",
    description: "Instagram, YouTube, Facebook / 720 qualifizierte Klicks / 30 Tage",
    color: "#f5c889",
    selectedChannels: [facebook, youtube, instagram]
  },
  {
    budget: 1200,
    minClicks: 320,
    name: "IT Booster",
    id: "aws--it-booster",
    nameShort: "💻",
    description: "Twitter & Reddit / 320 qualifizierte Klicks / 30 Tage",
    color: "#93a3fb",
    selectedChannels: [twitter, reddit]
  },

  {
    budget: 1200,
    minClicks: 720,
    name: "Pflege Booster",
    id: "aws--pflege-booster",
    nameShort: "🚑",
    description: "Instagram, YouTube, Facebook / 720 qualifizierte Klicks / 30 Tage",
    color: "#ffbebe",
    selectedChannels: [facebook, youtube, instagram]
  },

  {
    budget: 1200,
    minClicks: 480,
    name: "Azubi Booster",
    id: "aws--azubi-booster",
    nameShort: "😎",
    description: "Instagram, Snapchat / 480 qualifizierte Klicks / 30 Tage",
    color: "#e6ef61",
    selectedChannels: [snapchat, instagram]
  },
  {
    budget: 169,
    minClicks: 100,
    name: "Knappschaft Facebook",
    id: "aws--knappschaft-fb",
    nameShort: "😎",
    description: "Facebook / 100 qualifizierte Klicks / 30 Tage",
    color: "#2fdcb4",
    selectedChannels: [facebook]
  }
];
